export default function createAssetGetter(filename: string): AssetUrlGetter {
    return (domain: string): string => {
        return `${domain}/${filename}`;
    };
}
